import React, { Component, Fragment } from 'react';
import _, { isEmpty, size } from "lodash";

import SalaryForm from './SalaryForm';
import SalaryDetails from './SalaryDetails';
import Pagination from '../../../container/MUI/Pagination';
import { AddCircle, MoreVertRounded, FilterListRounded, CloudDownloadRounded } from '@mui/icons-material';

import { 
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button, 
    Box,
    TableContainer,
    Menu,
    MenuItem,
    Checkbox,
    Grid
} from '@mui/material';
import EmployeeForm from './EmployeeForm';
import { MONTHS } from '../../../utils/generalFuncs';
import TabsContent from '../../common/TabsContent';
import ChargesList from './ChargesList';
import EmployeesList from './EmployeesList';
import SalaryCatsList from './SalaryCatsList';
import { EnhancedTableHead, EnhancedTableToolbar } from '../../../container/MUI/EnhancedTable';
import FilterSalaries from './FilterSalaries';
import PaymentForm from '../Payments/PaymentFormAll';
import Spinner from '../../common/Spinner';
import DeleteDialog from '../../common/DeleteDialog';

class SalariesList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 20,
        
        openForm: false,
        openEmployee: false,
        openFilters: true,

        openDetails: false,
        salary: {},
        deleteSalary: false,
        toDelete: {},

        anchorEl: null, 
        openMenu: "", 
        checkedItems: [],
        
        pay_status: "",
        searchMonth: "",
        searchYear: 2022,
        // searchYear: new Date().getFullYear(),
        searchEmployee: {value: "", label: ""},
        searchCat: {value: "", label: ""}

    }
    componentWillMount() {
        window.scrollTo(0, 0);
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };
    
    filterList = () => {
        const { searchEmployee, searchMonth, searchYear, pay_status} = this.state;
        const { SALARIES } = this.props
        
        let filteredList = Object.values(SALARIES)
        if( !isEmpty(pay_status)) {
            filteredList = filteredList.filter( item => item.salary_status === pay_status)
        }
        // if( !isEmpty(searchEmployee.value)) {
        //     filteredList = filteredList.filter( item => item.salary_employee === searchEmployee.value)
        // }
        // if( searchMonth ) {
        //     filteredList = filteredList.filter( item => new Date(item.salary_period_end).getMonth() == searchMonth)
        // }
        // if( searchYear ) {
        //     filteredList = filteredList.filter( item => new Date(item.salary_period_end).getFullYear() == searchYear)
        // }

         
        if( !isEmpty(searchEmployee.value)) {
            filteredList = filteredList.filter( item => item.salary_employee === searchEmployee.value)
        }
        if( Array.isArray(searchEmployee) && !isEmpty(searchEmployee) ) {
            let itemList = searchEmployee.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(item.salary_employee))
        }

        if( !isEmpty(searchMonth.value) ) {
            filteredList = filteredList.filter( item => new Date(item.salary_period_end).getMonth() == searchMonth)
        } else if( Array.isArray(searchMonth) && !isEmpty(searchMonth)) {
            let itemList = searchMonth.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.salary_period_end).getMonth()))
        } 

        if( searchYear ) {
            filteredList = filteredList.filter( item => new Date(item.salary_period_end).getFullYear() == searchYear)
        }
        if( Array.isArray(searchYear) ) {
            let itemList = searchYear.map(item => item.value )
            filteredList = filteredList.filter( item => itemList.includes(new Date(item.salary_period_end).getFullYear()))
        } 

        // console.log('====================================');
        // console.log({filteredList});
        // console.log('====================================');
        return filteredList
    }
    displayList = () => {
        const { SALARIES, EMPLOYEES } = this.props;
        let tab = []
        let maxSelect = 0
        let rows = 0
        if (!isEmpty(SALARIES) && !isEmpty(EMPLOYEES) ){
            let filteredList = this.filterList()
            rows = size(filteredList)
            tab.push( this.getSalaryList(filteredList))
            maxSelect = size(filteredList.filter( item => item.salary_status === "WAITING"))
        }
        return [tab, rows, maxSelect]
    }
    getSalaryList = (list) => {
        const { EMPLOYEES } = this.props
        const { rowsPerPage, page, openMenu, anchorEl, checkedItems } = this.state;

        const isSelected = name => checkedItems.indexOf(name) !== -1;
        
        return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => {

            let isItemSelected = isSelected(item.salary_id)
            const labelId = `enhanced-table-checkbox-${index}`;

            return (
                <TableRow hover key={item.salary_id} className="clickable"
                    title="Voir le Détail"
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    selected={ isItemSelected }
                >
                    <TableCell 
                        padding="checkbox"
                    >
                    {!item.salary_fully_paid &&
                        <Checkbox
                            onClick={event => this.handleClick(event, item.salary_id)}
                            disabled={item.salary_fully_paid}
                            checked={isItemSelected}
                            inputProps={{ 'aria-labelledby': labelId }}
                        />
                    }
                    </TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, salary: item })}    
                    > {new Date(item.salary_date).toLocaleDateString('fr-FR')}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, salary: item })}    
                    > {MONTHS[new Date(item.salary_period_end).getMonth()]} {new Date(item.salary_period_start).getFullYear()}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, salary: item })}    
                    > {item.salary_employee && EMPLOYEES[item.salary_employee].employee_lastname}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, salary: item })}    
                    > {item.salary_employee && EMPLOYEES[item.salary_employee].employee_firstname}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, salary: item })}    
                    > {item.salary_to_pay}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, salary: item })}    
                    > {item.salary_rest_to_pay}</TableCell>
                    <TableCell
                        onClick={() => this.setState({ openDetails: true, salary: item })}    
                    > {item.salary_status}</TableCell>
                    <TableCell>
                        {!item.salary_fully_paid &&
                            <Fragment>
                                <IconButton 
                                    aria-controls={`option-menu${item.salary_id}`} 
                                    aria-haspopup="true"
                                    onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : item.salary_id}) }>
                                    <MoreVertRounded/>
                                </IconButton>

                                <Menu
                                    id={`option-menu${item.salary_id}`}
                                    anchorEl={anchorEl}
                                    getContentAnchorEl={null}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    open={ openMenu === item.salary_id}
                                    onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                >
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            newPayment: true, 
                                            singlePayment: [item.salary_id], 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Paiement
                                    </MenuItem>
                                    {item.salary_total_payed === 0 &&
                                    <MenuItem 
                                        onClick={() => this.setState({ 
                                            deleteSalary: true, 
                                            toDelete: item, 
                                            openMenu: "", 
                                            anchorEl:null}) 
                                        }
                                    >
                                        Supprimer
                                    </MenuItem>
                                    }
                            </Menu>
                        </Fragment>
                        }
                    </TableCell>
                </TableRow>
            )
        })    
    }

    handleClick = (event, name) => {
        const { checkedItems } = this.state;
        const selectedIndex = checkedItems.indexOf(name);
        let newSelected = [];
    
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(checkedItems, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(checkedItems.slice(1));
        } else if (selectedIndex === checkedItems.length - 1) {
            newSelected = newSelected.concat(checkedItems.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                checkedItems.slice(0, selectedIndex),
                checkedItems.slice(selectedIndex + 1),
            );
        }
    
        // console.log('====================================');
        // console.log({newSelected, name, event});
        // console.log('====================================');
        this.setState({
            checkedItems : newSelected
        });
    };
    handleClose = () => {
		this.setState({ 
            openDetails: false,
            salary: {},
            openForm: false,
            openEmployee: false,
        });
    };    
    // SEARCH
    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
            checkedItems :[],
            page: 0,
        })
    
    }
    handleSelect = (option, name) => {
        if(option){
            this.setState({                
                [name]: option,
                page: 0,
                checkedItems :[]
            })
        } else {
            this.setState({
                [name]: {label: "", value: ""},
                page: 0,
                checkedItems :[]
            })

        }
    
    }
    handleChangeEmployee = (option) => {
        if(option){
            this.setState({                
                searchEmployee: option,
                page: 0,
                checkedItems :[]
            })
        } else {
            this.setState({
                searchEmployee: {label: "", value: ""},
                page: 0,
                checkedItems :[]
            })

        }
    }
    handleChangeCat = (option) => {
        if(option){
            this.setState({                
                searchCat: option,
                page: 0,
                checkedItems :[]
            })
        } else {
            this.setState({
                searchCat: {label: "", value: ""},
                page: 0,
                checkedItems :[]
            })
        }
    }
    handleSelectAllClick = event => {
        console.log('===============CHECKED ?=====================');
        console.log(event.target.checked);
        console.log('====================================');
        if (event.target.checked) {
            let filteredList = this.filterList()
            filteredList = filteredList.filter( item => item.salary_status === "WAITING")
            const newSelecteds = filteredList.map(item => item.salary_id);
            this.setState({
                checkedItems : newSelecteds
            });
          return;
        }
        this.setState({
            checkedItems :[]
        });
    };
    handleDelete = async () => {
        const { toDelete } = this.state;
        await this.props.deleteSalary(toDelete)
        if(this.props.STATE.salaries.error){
            this.props.notif("error", this.props.STATE.salaries.error)
        } else {
            
            this.props.notif("success", "Salaire supprimé")
            this.setState({
                deleteSalary: false,
                toDelete: {},
            })
        }
    }
    render() {
        const { SALARIES, EMPLOYEES  } = this.props;
        const { rowsPerPage, page, openForm, openDetails, salary, openEmployee, checkedItems, newPayment, singlePayment, openFilters, deleteSalary, toDelete } = this.state;
        console.log('==== STATE SALARY LIST ================================');
        console.log(this.state);
        console.log('====================================');
        let list = this.displayList()
        // let total = 0
        // if(!isEmpty(checkedItems) ){
        //     checkedItems.forEach(ID => total += SALARIES[ID].salary_rest_to_pay)
        // }
        return (
            <Box>
                {openEmployee &&
                    <EmployeeForm handleClose={this.handleClose} {...this.props} />
                }
                {openDetails && !isEmpty(salary) && 
                    <SalaryDetails handleClose={this.handleClose} {...this.props} salary={salary} />
                }
                {openForm &&
                    <SalaryForm handleClose={this.handleClose} {...this.props} />
                }

                {newPayment && !isEmpty(checkedItems) &&
                    // <SalaryPaymentForm
                    <PaymentForm
                        salaries={checkedItems}
                        handleClose={() => this.setState({ newPayment: false, checkedItems:[] })}
                        // total={total }
                        {...this.props}
                    />
                }
                {newPayment && !isEmpty(singlePayment) &&
                    <PaymentForm
                        salaries={singlePayment }
                        handleClose={() => this.setState({ newPayment: false, singlePayment: [] })}
                        {...this.props}
                    />
                }
                {deleteSalary && toDelete &&
                    <DeleteDialog
                        title={"le salaire"}
                        open={true}
                        close={() => this.setState({ deleteSalary: false, toDelete: {} })}
                        handleSubmit={this.handleDelete}
                        disabled={this.props.STATE.salaries.fetching}
                    />
                }
                
                {this.props.STATE.salaries.fetching ?
                    <Spinner />
                    :    
                    <TabsContent
                        labels={["Salaires", "Charges", "Employés", "Rubriques"]}
                    >
                        <Fragment>
                            <Box>
                                <Typography variant="h6" id="tableTitle">
                                    Liste des Salaires
                                </Typography>
                                <Box p={2}>
                                    <Grid container spacing={2}>
                                        <Grid item sm={6} xs={12}>
                                            <Button 
                                                variant="outlined" 
                                                color="secondary"
                                                onClick={() => this.setState({ openFilters: !this.state.openFilters })}
                                                startIcon={<FilterListRounded />}
                                            >
                                                Filtres
                                            </Button>
                                        </Grid>
                                        <Grid item sm={6} xs={12} style={{textAlign: "right"}}>
                                            <Button variant="contained" color="secondary" 
                                                onClick={() => this.setState({ openForm: true })} 
                                                title="Nouvelle fiche de Paie"
                                                startIcon={<AddCircle />}
                                            >
                                                Salaire
                                            </Button>
                                            <Button variant="contained" color="primary" 
                                                onClick={() => this.setState({ openEmployee: true })} 
                                                title="Nouvel Employé"
                                                startIcon={<AddCircle />}
                                            >
                                                Employé
                                            </Button>
                                            <IconButton color="primary" onClick={() => this.props.openFormDownload("/extract/salary")} title="Télécharger" disabled={this.props.downloading}>
                                                <CloudDownloadRounded />
                                            </IconButton>
                                        
                                        </Grid>
                                    </Grid>
                                </Box>
                                
                                {openFilters && 
                                    <FilterSalaries
                                        EMPLOYEES={EMPLOYEES}
                                        handleChange={this.handleChange}
                                        handleChangeEmployee={this.handleChangeEmployee}
                                        handleSelect={this.handleSelect}
                                        {...this.state}
                                    />
                                }
                                {!isEmpty(checkedItems) &&
                                    <EnhancedTableToolbar 
                                        numSelected={size(checkedItems)} 
                                        action={() => this.setState({ newPayment: true })}
                                    />
                                }
                                {!isEmpty(SALARIES) && 
                                    <TableContainer>
                                        <Table>
                                            <EnhancedTableHead
                                                numSelected={size(checkedItems)}
                                                onSelectAllClick={this.handleSelectAllClick}
                                                rowCount={list[2]}
                                                headers={[
                                                    { id: 'salary_date', numeric: false, disablePadding: false, label: 'Créé le' },
                                                    { id: 'salary_period_start', numeric: false, disablePadding: false, label: 'Période' },
                                                    { id: 'lastname', numeric: false, disablePadding: false, label: 'Nom' },
                                                    { id: 'firstname', numeric: false, disablePadding: false, label: 'Prénom' },
                                                    { id: 'salary_to_pay', numeric: true, disablePadding: false, label: 'Montant' },
                                                    { id: 'salary_rest_to_pay', numeric: true, disablePadding: false, label: 'Reste à Payer' },
                                                    { id: 'salary_status', numeric: false, disablePadding: false, label: 'Statut' },
                                                    { id: 'options', numeric: false, disablePadding: false, label: 'Options' },
                                                ]}
                                            />
                                                
                                            <TableBody>
                                                {list[0]}
                                            </TableBody>
                                            <TableFooter>
                                                <TableRow>
                                                    <TablePagination
                                                        rowsPerPageOptions={[20, 30]}
                                                        labelRowsPerPage="Lignes par Page"
                                                        colSpan={9}
                                                        count={list[1]}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        SelectProps={{
                                                            native: true,
                                                        }}
                                                        onPageChange={this.handleChangePage}
                                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                        ActionsComponent={Pagination}
                                                    />
                                                </TableRow>
                                            </TableFooter>
                                        </Table> 
                                    </TableContainer>
                                }
                            </Box>
                        </Fragment>
                        <ChargesList 
                            {...this.props} 
                            {...this.state} 
                            handleOpenFilters={() => this.setState({ openFilters: !this.state.openFilters })} 
                            handleChange={this.handleChange}
                            handleChangeEmployee={this.handleChangeEmployee}
                            handleChangeCat={this.handleChangeCat}
                            handleSelect={this.handleSelect}

                        />
                        <EmployeesList 
                            {...this.props} 
                            handleChangeEmployee={this.handleChangeEmployee}
                            searchEmployee={this.state.searchEmployee}
                        />
                        <SalaryCatsList 
                            {...this.props} 
                            handleChangeCat={this.handleChangeCat}
                            searchCat={this.state.searchCat}
                        />
                    </TabsContent>
                }
            </Box>
        );
    }
}

export default SalariesList;